/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_menu-close': {
    width: 16,
    height: 16,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M7.719 6.281L6.28 7.72 23.563 25 6.28 42.281l1.44 1.439L25 26.437 42.281 43.72l1.438-1.438L26.437 25 43.72 7.719 42.28 6.28 25 23.563z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/icon_menu-close.js